/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Receivesnewsletter1Inputs */

const en__field_receivesnewsletter1 = /** @type {(inputs: _Field_Receivesnewsletter1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`receives newsletter`)
};

const de__field_receivesnewsletter1 = /** @type {(inputs: _Field_Receivesnewsletter1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`erhält Newsletter`)
};

/**
* | output |
* | --- |
* | "receives newsletter" |
*
* @param {_Field_Receivesnewsletter1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_receivesnewsletter1 = /** @type {((inputs?: _Field_Receivesnewsletter1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Receivesnewsletter1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_receivesnewsletter1(inputs)
	return de__field_receivesnewsletter1(inputs)
});
export { _field_receivesnewsletter1 as "_field_receivesNewsletter" }